import React from 'react';
import PropTypes from 'prop-types';

import FilterNumberPair from 'components/search_sidebar/filter_number_pair';
import FilterInput from 'components/search_sidebar/filter_input';
import FilterSelect from 'components/search_sidebar/filter_select';
import FilterCheckboxGroup from 'components/search_sidebar/filter_checkbox_group';
import FilterDatePickerPair from 'components/search_sidebar/filter_datepicker_pair';
import { CalendarPortal } from 'components/form/managed_input/date_input';
import { Col, Row } from 'react-bootstrap-5';

export default class BuildingFilters extends React.Component {
  lotUnits = [{ id: 'acres', value: 'acres', label: 'Acres' }];

  static propTypes = {
    buildingClasses: PropTypes.array.isRequired,
    filterKeyMappings: PropTypes.object.isRequired,
    filterLabelMappings: PropTypes.object.isRequired,
    investmentTypes: PropTypes.array.isRequired,
    propertyFilter: PropTypes.shape({
      lotUnits: PropTypes.string,
      apnNumber: PropTypes.string,
      maxBuildingSize: PropTypes.string,
      maxAvailableSF: PropTypes.string,
      maxCeilingHeight: PropTypes.string,
      maxLotSize: PropTypes.string,
      maxMortgageAmount: PropTypes.string,
      maxMortgageRecordedDate: PropTypes.string,
      maxNumUnits: PropTypes.string,
      maxYearBuilt: PropTypes.string,
      minAvailableSF: PropTypes.string,
      minBuildingSize: PropTypes.string,
      minCeilingHeight: PropTypes.string,
      minLotSize: PropTypes.string,
      minMortgageAmount: PropTypes.string,
      minMortgageRecordedDate: PropTypes.string,
      minNumUnits: PropTypes.string,
      minYearBuilt: PropTypes.string,
    }).isRequired,
    selectedBuildingClasses: PropTypes.array.isRequired,
    selectedInvestmentTypes: PropTypes.array.isRequired,
    onBuildingClassChange: PropTypes.func.isRequired,
    onInvestmentTypeChange: PropTypes.func.isRequired,
    onPropertyFilterChange: PropTypes.func.isRequired,
  };

  handleChange = (e, name) => {
    const { onPropertyFilterChange } = this.props;

    onPropertyFilterChange(e, name);
  };

  render() {
    const {
      buildingClasses,
      filterKeyMappings,
      filterLabelMappings,
      investmentTypes,
      propertyFilter,
      selectedBuildingClasses,
      selectedInvestmentTypes,
      onBuildingClassChange,
      onInvestmentTypeChange,
    } = this.props;

    return (
      <Row>
        <Col md={6}>
          <div className="d-flex flex-column gap-2">
            <Row className="d-md-flex d-none">
              <Col>
                <FilterCheckboxGroup
                  label="Investment Type"
                  options={investmentTypes}
                  selected={selectedInvestmentTypes}
                  onChange={onInvestmentTypeChange}
                />
              </Col>
            </Row>
            <Row className="d-none d-md-flex">
              <Col>
                <FilterCheckboxGroup
                  inline
                  label="Class"
                  options={buildingClasses}
                  selected={selectedBuildingClasses}
                  onChange={onBuildingClassChange}
                />
              </Col>
            </Row>
            <Row className="gx-2 align-items-end">
              <Col md={9}>
                <FilterNumberPair
                  filter={propertyFilter}
                  label={filterLabelMappings['lotSize']}
                  name="lotSize"
                  valueKeys={filterKeyMappings['lotSize']}
                  onChange={this.handleChange}
                />
              </Col>
              <Col className="d-none d-md-flex" md={3}>
                <FilterSelect
                  defaultValue="sf"
                  options={this.lotUnits}
                  placeholder="SF"
                  value={propertyFilter.lotUnits}
                  onChange={e => this.handleChange(e, 'lotUnits')}
                />
              </Col>
            </Row>
            <Row className="d-none d-md-flex">
              <Col>
                <FilterInput
                  label={filterLabelMappings['apnNumber']}
                  name="apnNumber"
                  placeholder="Parcel Number"
                  value={propertyFilter.apnNumber}
                  onChange={e => this.handleChange(e, 'apnNumber')}
                />
              </Col>
            </Row>
            <Row className="gx-2 align-items-end">
              <Col md={9}>
                <FilterNumberPair
                  filter={propertyFilter}
                  label={filterLabelMappings['buildingSize']}
                  name="buildingSize"
                  valueKeys={filterKeyMappings['buildingSize']}
                  onChange={this.handleChange}
                />
              </Col>
              <Col className="d-none d-md-flex" md={3}>
                <FilterSelect disabled placeholder="SF" />
              </Col>
            </Row>
            <Row className="d-none d-md-flex">
              <Col>
                <FilterNumberPair
                  filter={propertyFilter}
                  label={filterLabelMappings['mortgageAmount']}
                  name="mortgageAmount"
                  valueKeys={filterKeyMappings['mortgageAmount']}
                  onChange={this.handleChange}
                />
              </Col>
            </Row>
          </div>
        </Col>
        <Col md={6}>
          <div className="d-flex flex-column gap-2">
            <Row>
              <Col>
                <FilterNumberPair
                  filter={propertyFilter}
                  label={filterLabelMappings['numUnits']}
                  name="numUnits"
                  valueKeys={filterKeyMappings['numUnits']}
                  onChange={this.handleChange}
                />
              </Col>
            </Row>
            <Row className="gx-2 align-items-end">
              <Col md={9}>
                <FilterNumberPair
                  filter={propertyFilter}
                  label={filterLabelMappings['ceilingHeight']}
                  name="ceilingHeight"
                  valueKeys={filterKeyMappings['ceilingHeight']}
                  onChange={this.handleChange}
                />
              </Col>
              <Col className="d-none d-md-flex" md={3}>
                <FilterSelect disabled placeholder="FT" />
              </Col>
            </Row>
            <Row>
              <Col>
                <FilterNumberPair
                  filter={propertyFilter}
                  label={filterLabelMappings['yearBuilt']}
                  name="yearBuilt"
                  placeholder="Year"
                  valueKeys={filterKeyMappings['yearBuilt']}
                  onChange={this.handleChange}
                />
              </Col>
            </Row>
            <Row className="gx-2 align-items-end">
              <Col md={9}>
                <FilterNumberPair
                  filter={propertyFilter}
                  label={filterLabelMappings['availableSF']}
                  name="availableSF"
                  placeholder="Available SF"
                  valueKeys={filterKeyMappings['availableSF']}
                  onChange={this.handleChange}
                />
              </Col>
              <Col className="d-none d-md-flex" md={3}>
                <FilterSelect disabled placeholder="SF" />
              </Col>
            </Row>
            <Row className="d-md-none d-flex">
              <Col>
                <FilterSelect disabled placeholder="SF" />
              </Col>
            </Row>
            <Row>
              <Col>
                <FilterDatePickerPair
                  filter={propertyFilter}
                  label={filterLabelMappings['mortgageRecordedDate']}
                  name={filterLabelMappings['mortgageRecordedDate']}
                  popperContainer={CalendarPortal}
                  valueKeys={filterKeyMappings['mortgageRecordedDate']}
                  onChange={this.handleChange}
                />
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    );
  }
}
